import React, { useCallback, useContext, useMemo, useState } from 'react';

import { MobXProviderContext, observer } from 'mobx-react';

import { Button, Form, Radio } from 'semantic-ui-react';

import '../../css/AddJoinRosterModal.less';

import { SatCoreComponent, SatCoreRegister } from '../../SatCoreRegistry';

import Modal from '../Modal';

const AddJoinRosterModal = observer((props) => {
  const {
    open,
    close,
    handleLaunchGoogleClassroomRosterConnectionModalIfAuthorized,
    handleRegisterStudentModal,
    // openAddModal,
    // openGoogleClassroomConnectionModal,
    // openJoinModal,
    t
  } = props;

  const { googleClassroomManager } = useContext(MobXProviderContext);

  const ModalBanner = useMemo(() => SatCoreComponent('ModalBanner'), []);
  const [selectedClassroomOptionValue, setSelectedClassroomOptionValue] = useState(null);
  const onSave = useCallback(async () => {
    close();
    switch (selectedClassroomOptionValue) {
      case 'addNewStudent':
        handleRegisterStudentModal();
        break;
      case 'importGoogleClassroomRosterUsers':
        await handleLaunchGoogleClassroomRosterConnectionModalIfAuthorized();
        break;
      default:
        break;
    }
  }, [
    close,
    handleLaunchGoogleClassroomRosterConnectionModalIfAuthorized,
    handleRegisterStudentModal,
    selectedClassroomOptionValue
  ]);

  const renderClassroomModalOption = (optionValue, optionLabelKey) => {
    if (!optionValue) {
      return null;
    }
    optionLabelKey = optionLabelKey || optionValue;
    return (
      <Form.Field>
        <Radio
          checked={selectedClassroomOptionValue === optionValue}
          label={t(optionLabelKey)}
          name='radioGroup'
          onChange={(_event, _data) => setSelectedClassroomOptionValue(optionValue)}
          value='new' />
      </Form.Field>
    );
  };

  return (
    <Modal
      className='add-join-roster-modal'
      closeOnDimmerClick={false}
      closeOnEscape={true}
      onClose={close}
      open={open}>
      <ModalBanner onClose={close} title={t('addJoinRosterModalBannerTitle')} />
      <Modal.Content>
        {renderClassroomModalOption('addNewStudent')}
        {googleClassroomManager.allowGoogleClassroomIntegration && (
          renderClassroomModalOption('importGoogleClassroomRosterUsers')
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button basic className='cancelButton' onClick={close} primary>
          {t('cancel')}
        </Button>
        <Button className='ui primary button saveButton' disabled={selectedClassroomOptionValue === null} onClick={onSave}>
          {t('save')}
        </Button>
      </Modal.Actions>
    </Modal>
  );
});

export default AddJoinRosterModal;

SatCoreRegister('AddJoinRosterModal', AddJoinRosterModal);
